type ImgMap = {
  [key: string]: string;
};

export const programsBuyPointLink: ImgMap = {
  av: "https://www.lifemiles.com/miles/buy",
  ua: "https://buymiles.mileageplus.com/united/marchtransfer/index_en.html",
  af: "https://buymiles.mileageplus.com/united/marchtransfer/index_en.html",
  as: "https://storefront.points.com/mileage-plan/en-US/buy?irgwc=1&referralCode=",
  ac: "https://www.aircanada.com/ca/en/aco/home/aeroplan/your-aeroplan.html",
  b6: "https://trueblue.jetblue.com/buy-points/?irgwc=1&referralCode=",
  vs: "https://flywith.virginatlantic.com/gb/en/flying-club/earn-points/buy-points.html",
  f9: "https://buy.points.com/marketing/frontier/",
  aa: "https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy",
};

export const bankCardImg: ImgMap = {
  bilt: "https://img.awardtool.com/bilt_1x.png",
  chase: "https://img.awardtool.com/chase_1x.png",
  amex: "https://img.awardtool.com/amex_1x.png",
  "capital one": "https://img.awardtool.com/capital_one_1x.png",
  citi: "https://img.awardtool.com/citi_1x.png",
  marriott: "https://img.awardtool.com/marriott_1x.png",
  "wells fargo": "https://img.awardtool.com/wells_fargo_1x_v3.png",
};

export const bankCardSmallImg: ImgMap = {
  bilt: "https://img.awardtool.com/bank_img/bilt_small.png",
  chase: "https://img.awardtool.com/bank_img/chase_small.png",
  amex: "https://img.awardtool.com/bank_img/amex_small.png",
  "capital one": "https://img.awardtool.com/bank_img/capital_one_small.png",
  citi: "https://img.awardtool.com/bank_img/citi_small.png",
  marriott: "https://img.awardtool.com/bank_img/marriott_small.png",
  "wells fargo": "https://img.awardtool.com/bank_img/wells_fargo_small.png",
};
